var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { html, LitElement } from 'lit';
import css from './style.pcss';
import translations from './translations';
import CameraImageA1 from "./images/trafic-camera-a1.jpg";
import CameraImageA3 from "./images/trafic-camera-a3.jpg";
import CameraImageA4 from "./images/trafic-camera-a4.jpg";
import CameraImageA6 from "./images/trafic-camera-a6.jpg";
import CameraImageA7 from "./images/trafic-camera-a7.jpg";
import CameraImageA13 from "./images/trafic-camera-a13.jpg";
var CameraImages = {
  a1: CameraImageA1,
  a3: CameraImageA3,
  a4: CameraImageA4,
  a6: CameraImageA6,
  a7: CameraImageA7,
  a13: CameraImageA13
};
var RTLTraficCams = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLTraficCams, _LitElement);
  function RTLTraficCams() {
    var _this;
    _classCallCheck(this, RTLTraficCams);
    _this = _callSuper(this, RTLTraficCams);
    _this.language = 'lu';
    _this.route = 'A1';
    _this.showimages = false;
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLTraficCams, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLTraficCams.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      var apiUrl = `https://api-gate.rtl.lu/traffic/highways`;
      fetch(apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        //console.log(this.data);
      });
    }
  }, {
    key: "_changeRoute",
    value: function _changeRoute(e, id) {
      this.route = id;
      this.querySelector('.rtl-trafic-cams-nav__item--active').classList.remove('rtl-trafic-cams-nav__item--active');
      e.target.classList.add('rtl-trafic-cams-nav__item--active');
    }
  }, {
    key: "_showCams",
    value: function _showCams(e) {
      this.querySelector('.rtl-trafic-cams__static').classList.toggle('rtl-trafic-cams__static--hidden');
      if (e.target.innerHTML == this._getTranslation('hide_cams')) e.target.innerHTML = this._getTranslation('show_cams');else e.target.innerHTML = this._getTranslation('hide_cams');
    }
  }, {
    key: "_renderCams",
    value: function _renderCams() {
      var _this3 = this;
      var route = this.data.find(function (route) {
        return route.id === _this3.route;
      });
      return html(_t || (_t = _`
            <div class="rtl-trafic-cams__video">
                <div class="media-video">
                    <div class="media-video__title">${0}</div>
                    <rtl-player hls="${0}" poster="${0}" class="media-video__player"></rtl-player>
                </div>
            </div>

            ${0}

            ${0}

        `), route.title, route.stream_url, CameraImages[route.id.toLowerCase()], !this.showimages ? html(_t2 || (_t2 = _`<div class="button-container-co"><div class="button-default-co" @click=${0}>${0}</div></div>`), function (e) {
        return _this3._showCams(e);
      }, this._getTranslation('show_cams')) : '', !this.showimages ? html(_t3 || (_t3 = _`
                <div class="rtl-trafic-cams__static rtl-trafic-cams__static--hidden">
                    ${0}
                </div>
            `), route.cameras.map(function (cam) {
        return html(_t4 || (_t4 = _`
                    <div class="rtl-trafic-camera">
                        <div class="rtl-trafic-camera__image"><img src="${0}" /></div>
                        <div class="rtl-trafic-camera__label">${0} - ${0}</div>
                    </div>
                    `), cam.image_url, cam.from, cam.to);
      })) : html(_t5 || (_t5 = _`
                <div class="rtl-trafic-cams__static">
                    ${0}
                </div>
            `), route.cameras.map(function (cam) {
        return html(_t6 || (_t6 = _`
                    <div class="rtl-trafic-camera">
                        <div class="rtl-trafic-camera__image"><img src="${0}" /></div>
                        <div class="rtl-trafic-camera__label">${0} - ${0}</div>
                    </div>
                    `), cam.image_url, cam.from, cam.to);
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      if (this.data == undefined) return html(_t7 || (_t7 = _`Loading...`));
      return html(_t8 || (_t8 = _`
            <style>${0}</style>
            <div class="rtl-trafic-cams rtl-trafic-cams--${0}">
                <div class="l-section__title">
                    <div class="l-section__title-text">${0}</div>
                </div>
                <ul class="rtl-trafic-cams__nav rtl-trafic-cams-nav">
                ${0}
                </ul>
                ${0}
            </div>
        `), css, this.language, this._getTranslation('title'), this.data.map(function (route, key) {
        return html(_t9 || (_t9 = _`
                    <li class="rtl-trafic-cams-nav__item${0}" @click=${0}>
                        ${0}
                    </li>
                `), route.id == _this4.route ? ' rtl-trafic-cams-nav__item--active' : '', function (e) {
          return _this4._changeRoute(e, route.id);
        }, route.id);
      }), this._renderCams());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        language: {
          type: String
        },
        route: {
          type: String
        },
        showimages: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLTraficCams;
}(LitElement);
export { RTLTraficCams as default };
window.customElements.define('rtl-trafic-cams', RTLTraficCams);